import * as yup from 'yup'

export interface PartnersFeesTItemType {
  rowNum?: number,
  partnersFeesTId: number,
  stateId: number,
  homeState: string,
  partnerId: number,
  customerName: string,
  zeroFee: number,
  premiumFee: number,
  policyFee: number,
  loydsFee: number,
  binderFee: number,
  endorsementFee: number,
  largeReportFee: number,
  diligentSearchFee: number,
  dateAsOf: string,
  isLatest: boolean,
}

export const PartnersFeesT_VS = yup.object({
  stateId: yup.number().strict(true)
    .typeError('Select a state')
    .moreThan(0, 'Select a state')
    .required('Please select the state.'),
  partnerId: yup.number().strict(true)
    .typeError('Select a client')
    .moreThan(0, 'Select a client')
    .required('Please select the client.'),
  dateAsOf: yup.string().required('Please select the date'),
})

export const PartnersFeesT_VS_bulkAdd = yup.object({
  partnerId: yup.number().strict(true)
    .typeError('Select a client')
    .moreThan(0, 'Select a client')
    .required('Please select the client.'),
  dateAsOf: yup.string().required('Please select the date'),
})
